import React from "react";
import { LayoutHeader } from "../components";
import { Welcome } from "../containers";

const MainPage = () => (
  <LayoutHeader>
    <Welcome />
  </LayoutHeader>
);

export default MainPage;
